import { Routes, Route, NavLink, Navigate } from 'react-router-dom';
import Dashboard from './pages/Dashboard';
import Vtt from './pages/Vtt';
import Sheet from './pages/Sheet';
import LevelUp from './pages/LevelUp';

export default function App() {
  return (
    <div className="app-shell">
      <nav className="app-nav">
        <span className="app-nav__brand">GoobDoob VTT</span>
        <NavLink to="/dashboard" className="app-nav__link">Dashboard</NavLink>
        <NavLink to="/vtt" className="app-nav__link">VTT</NavLink>
        <NavLink to="/sheet" className="app-nav__link">Sheet</NavLink>
        <NavLink to="/levelup" className="app-nav__link">Level Up</NavLink>
      </nav>
      <main className="app-main">
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/vtt" element={<Vtt />} />
          <Route path="/sheet" element={<Sheet />} />
          <Route path="/levelup" element={<LevelUp />} />
        </Routes>
      </main>
    </div>
  );
}
